import React, { createContext, useEffect, useState } from "react";
import MainPage from "./MainPage";
import TimedOutPage from "./TimedOutPage";
import LoginPage from "./LoginPage";
import useRemote from "./hooks/useRemote";

const AppContext = createContext({});

const REMEMBER_ME_TOKEN = "learn.jumbletree.rememberme";
const App = ()=>{

	const remote = useRemote();

	const [ authenticated, setAuthenticated ] = useState(false);
	const [ timedout, setTimedout ] = useState(false);
	const [ firstLogin, setFirstLogin ] = useState(false);
	const [ user, setUser ] = useState(null);
	const [ school, setSchool ] = useState(null);

	useEffect(()=>{
		const token = localStorage.getItem(REMEMBER_ME_TOKEN);
		if (token) {
			remote.checkRememberMeToken(token)
				.then(resp=>{
					if (resp.valid) {
						setUser(resp.user.email);
						setSchool(resp.user.school);
						setFirstLogin(false);
						setAuthenticated(true);
					}
				});
		}
	}, []);

	return <AppContext.Provider value={{
		authenticated, setAuthenticated,
		timedout, setTimedout,
		user, setUser,
		school, setSchool,
		firstLogin, setFirstLogin
	}}>
		{authenticated ? <MainPage /> : (
			timedout ? <TimedOutPage /> : <LoginPage />
		)}
	</AppContext.Provider>
}

export default App;
export { AppContext, REMEMBER_ME_TOKEN };